import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-delete-btn',
  imports: [],
  templateUrl: './delete-btn.component.html',
  styleUrl: './delete-btn.component.scss'
})
export class DeleteBtnComponent {
  @Output() clicked = new EventEmitter<void>();

  onClick(): void {
    this.clicked.emit();
  }
}
